import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import EventCategoryCard from '../Card/EventCategoryCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import batchImg from '../../assets/images/practics-banner.png';
import { cx } from '@emotion/css';
import * as styles from './practice.style.js';
import { select } from '../../styles/components/forms.style';
import Select from 'react-select';
Amplify.configure(config);

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

function PracticeCatScreen() {
  const [level, setLevel] = useState(5);
  const [events_category, set_events_category] = useState([]);
  const [loadedcategories, set_loadedcategories] = useState(true);
  const [grade_user, set_grade_user] = useState(5);
  const [premiumlevel, set_premiumlevel] = useState(0);
  const leveloptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(() => getToken())
      .catch(() => {
        set_grade_user(5);
        loadCategories(5);
      });
    document.title = 'Practice Categories';
  }, []);

  useEffect(() => {
    loadCategories(grade_user);
  }, [grade_user]);

  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const res = await Auth.currentSession();
      const accessToken = res.getAccessToken();
      const jwt = accessToken.getJwtToken();

      if (user.username.includes("Google_")) {
        getuserDetails(user.attributes['email'], jwt);
      } else {
        getuserDetails(user.username, jwt);
      }
    } catch (error) {
      console.log("User not logged in");
      set_loadedcategories(true);
      loadCategories(5);
    }
  };

  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };
    const response = await fetch(`https://api.quizwizard.net/quiz/getuser`, requestOptions);
    const data = await response.json();

    set_grade_user(data['grade']);
    setLevel(data['grade']); // Automatically show the user's grade
    set_premiumlevel(data['premiumuser']);
    loadCategories(data['grade']);
  };

  const loadCategories = (grade) => {
    const quizes = importAll(require.context('./resources', true, /\.(json)$/));
    const keys = Object.keys(quizes);

    let categorylist = [];
    let change = "";
    let currentGrade = `Grade${grade}`;

    for (let i = 0; i < keys.length; i++) {
      if (keys[i].includes(currentGrade)) {
        if (change !== keys[i].split("/")[0]) {
          if (change !== '') {
            categorylist.push(change);
          }
          change = keys[i].split("/")[0];
        }
      }
    }
    categorylist.push(change);

    let data1 = [];
    let serialnumber = 0;
    categorylist.forEach(category => {
      let cat_count = 0;
      keys.forEach(key => {
        if (key.includes(category) && key.includes(currentGrade)) {
          cat_count++;
        }
      });

      if (cat_count > 0) {
        data1.push({
          id: ++serialnumber,
          category: category,
          count: cat_count,
          level: grade,
          premium: premiumlevel
        });
      }
    });

    set_events_category(data1);
    set_loadedcategories(true);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  let event_category_Cards = events_category.map((eventcategory) => {
    return (
      <div className="col-md-4" key={eventcategory.id}>
        <Col className="py-2 border rounded sfsdfs" key={eventcategory.id}>
          <EventCategoryCard
            imgsrc={'../assets/' + eventcategory.category + '.png'}
            title={eventcategory.category}
            key={eventcategory.id}
            eventcategory={eventcategory}
            premiumlevel={premiumlevel}
            target="practice"
          />
        </Col>
      </div>
    );
  });

  const handleGradeChange = (selectedGrade) => {
    set_grade_user(selectedGrade);
    loadCategories(selectedGrade);
  };


  return (
    <>
      <div>
        {loadedcategories ? (
          <div>
            <div className={cx(styles.batchBanner)}>
              <img src={batchImg} alt="" />
            </div>
            <div className={cx(styles.batchTitle)}>
              Let's practice some cool stuff
            </div>
            <div className={cx(styles.gradeSelectContainer)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  marginBottom: '50px'}}>
            <Select
              className="custom-select"
              classNamePrefix="select"
              name="level"
              options={leveloptions.map((times) => ({
                value: times,
                label: `Grade ${times}`,
              }))}
              onChange={(e) => {
                setLevel(e.value);
                handleGradeChange(e.value);
              }}
              value={{ value: level, label: `Grade ${level}` }}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  position: "relative",
                  width: "250px",
                  height: "50px",
                  borderRadius: "12px",
                  border: state.isFocused ? "2px solid rgb(241, 102, 2)" : "2px solid #ccc",
                  boxShadow: state.isFocused
                    ? "0px 4px 15px rgba(74, 144, 226, 0.3)"
                    : "0px 2px 10px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  transition: "all 0.3s ease-in-out",
                  fontWeight: "bold",
                  marginTop: "20px",
                  "&::before": {
                    content: '"Grade"',
                    position: "absolute",
                    top: "-10px",
                    left: "15px",
                    backgroundColor: "white",
                    padding: "0 5px",
                    fontSize: "14px",
                    color: state.isFocused ? "rgb(241, 102, 2)" : "#777",
                    transition: "all 0.3s ease",
                  },
                  "&:hover": { borderColor: "rgb(241, 102, 2)" },
                }),
                menu: (provided) => ({
                  ...provided,
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.9)",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  backdropFilter: "blur(12px)",
                  padding: "8px 0",
                  width: "100%",
                  minWidth: "250px",
                  boxSizing: "border-box", 
                  overflowX: "hidden",
                }),
                menuList: (provided) => ({
                  ...provided,
                  padding: "0",
                  whiteSpace: "nowrap",
                  maxHeight: "200px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingRight: "10px", // ✅ Prevents text from being cut off by scrollbar
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "rgb(241, 102, 2)"
                    : state.isFocused
                    ? "#E3F2FD"
                    : "transparent",
                  color: state.isSelected ? "#fff" : "#333",
                  fontWeight: state.isSelected ? "bold" : "normal",
                  padding: "12px 16px",
                  margin: "4px 8px",
                  borderRadius: "8px",
                  transition: "background 0.3s ease",
                  "&:hover": { backgroundColor: "#E3F2FD", color: "#000" },
                }),
                singleValue: (provided) => ({
                  ...provided,
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#333",
                }),
                dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "rgb(241, 102, 2)",
                  transition: "transform 0.3s ease-in-out",
                }),
              }}
            />






            </div>
            {event_category_Cards.length ? (
              <div className={cx(styles.practiceFluid)}>
                <Row> {event_category_Cards} </Row>
              </div>
            ) : (
              <div className={cx(styles.spellbowllicense)}>
                No Practice Events for Grade {grade_user}. Goto Settings and choose correct Grade
              </div>
            )}
          </div>
        ) : (
          <div className="welcomecenter">
            <Lottie options={defaultOptions} height={400} width={400} />
          </div>
        )}
      </div>
    </>
  );
}

export default PracticeCatScreen;


